import React from 'react';
import generateComponentKeyString from './generateComponentKeyString';
import ScrollRenderer from '../Renderers/ScrollRenderer';

export default (
    IrisWrapperComponent,
    irisContentMeta,
    index,
    irisComponents,
    propsData,
    limitInitialComponentsRendered = null
) => {
    const componentContent = irisContentMeta.content || {};
    const ComponentToRender = IrisWrapperComponent.component;
    const rndKeyString = generateComponentKeyString(irisContentMeta.componentType, index);

    const { mapToProps } = IrisWrapperComponent;
    const automationId = irisContentMeta.componentType;
    let mappedProps = {};
    const baseProps = {
        rndKeyString,
        ...propsData,
        automationId,
        irisComponentsWithoutGrid: irisComponents,
        componentType: irisContentMeta.componentType,
    };
    /* istanbul ignore else */
    if (mapToProps) {
        mappedProps = mapToProps(
            componentContent,
            baseProps.pageType,
            baseProps.deviceType,
            baseProps.preferences,
            baseProps.automationId,
            baseProps.featureFlags,
            baseProps.irisComponentsWithoutGrid,
            baseProps.componentType
        );
    } else {
        mappedProps = {
            ...irisContentMeta.content,
            ...baseProps,
        };
    }
    return typeof limitInitialComponentsRendered === 'number' &&
        index >= limitInitialComponentsRendered ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ScrollRenderer offset={propsData.offset} height={propsData.height} {...mappedProps}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <ComponentToRender key={rndKeyString} {...mappedProps} />
        </ScrollRenderer>
    ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ComponentToRender key={rndKeyString} {...mappedProps} />
    );
};
